import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "trashLearningExperiences",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-trash" */ "./components"),
        import(
          /* webpackChunkName: "admin-trash" */ "./modules/TrashLearningExperiencesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module2 = importedModule1;
        const reducer = module2.default;
        const key = module2.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
